import React from 'react';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import ValuesSection from '../components/ValuesSection';
import ApartmentsSection from '../components/ApartmentsSection';
import ScheduleVisitSection from '../components/ScheduleVisitSection';
import BlogSection from '../components/BlogSection';
import HowItWorksSplit from '../components/HowItWorksSplit';
import GallerySection from '../components/GallerySection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <ValuesSection />
      <ApartmentsSection />
      <HowItWorksSplit />
      {/* Interactive Image Section */}
      <section className="py-20">
        <div className="w-full">
          <img
            src="https://ik.imagekit.io/67mog36hf/Flowback/Forward%20111/Screenshot%202025-09-24%20at%2022.02.32.png?updatedAt=1758740829093"
            alt="Interactive Image"
            className="w-full h-auto cursor-pointer transition-transform duration-300 hover:scale-105"
            onClick={() => alert('Image clicked!')}
          />
        </div>
      </section>
        <BlogSection />
        <GallerySection />
        <ScheduleVisitSection />

    </div>
  );
};

export default HomePage;
